import { render, staticRenderFns } from "./xxcjConfig.vue?vue&type=template&id=1d314f6e&scoped=true"
import script from "./xxcjConfig.vue?vue&type=script&lang=js"
export * from "./xxcjConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d314f6e",
  null
  
)

export default component.exports